/* eslint-disable prettier/prettier */
import { all, takeLatest, select } from "redux-saga/effects";
import * as types from "./types";
import { get } from "lodash";
import { client } from "~/utils/medproSDK";
import history from "~/history";
import { BASE_URL } from "~/utils/constants";

function* requestCheckFilter({ isValid }) {
  try {
    const global = yield select(state => state.global);
    const platformType = get(global, "device.type");
    const platform = platformType === "desktop" ? "pc" : "web";
    const totalDataReducer = yield select(state => state.totalData);
    const partnerid = get(totalDataReducer, "partnerId");

    const hasInsuranceService = get(
      totalDataReducer,
      "service.serviceType",
      "NO_INSURANCE_ONLY"
    );

    const response1 = yield client.checkFilter(
      {
        template: "INSURANCE",
        isValid,
        hasInsurance: hasInsuranceService === "INSURANCE_ONLY"
      },
      {
        partnerid,
        platform
      }
    );
    const { data } = response1;
    const { requiredFilterCheck, url } = data;
    if (!requiredFilterCheck) {
      // di nhu binh thuong
    } else {
      // url web view
      const indexWebview = url.indexOf(".vn");
      const webView = url.slice(indexWebview + 3);

      // url web
      const indexWeb = webView.indexOf("-app");
      const webUrl = `${webView.slice(0, indexWeb)}${webView.slice(
        indexWeb + 4
      )}`;

      // window.location.href = url;

      history.push(webUrl);
    }
  } catch (error) {
    console.log(error);
  }
}

function* requestGetNextStep({ id, text, plattform }) {
  try {
    const global = yield select(state => state.global);
    const platformType = get(global, "device.type");
    const platform = platformType === "desktop" ? "pc" : "web";
    const totalDataReducer = yield select(state => state.totalData);
    const partnerid = get(totalDataReducer, "partnerId");

    yield client.getNextStep(
      {
        sessionId: id,
        sessionData: { insuranceChoice: text }
      },
      {
        partnerid,
        platform
      }
    );

    const { pathname } = window.location;
    if (plattform === "app") {
      // app thì đổi url
      if (!pathname.includes("confirm")) {
        const index = pathname.indexOf("-app");
        const webUrl = `${pathname.slice(0, index + 4)}-confirm${pathname.slice(
          index + 4
        )}`;
        window.location.href = `${BASE_URL}${webUrl}`;
        // history.push(webUrl);
      }
    } else {
      // web thì call api rồi đá về lại web
      console.log(123);
    }
  } catch (error) {
    console.log(error);
  }
}

export default function* watcher() {
  yield all([
    takeLatest(types.CHECK_FILTER, requestCheckFilter),
    takeLatest(types.FILTER_GET_NEXT_STEP, requestGetNextStep)
  ]);
}
